import React, { FunctionComponent, useMemo } from "react";
import { Field, FormRenderProps, useFormState } from "react-final-form";
import { makeStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import Autocomplete from "../../../components/Autocomplete";
import DatePicker from "../../../components/DatePicker";
import Button from "../../../components/Button";
import { DATE_FORMATS } from "../../../constants";
import { EDUCATION_TYPE_OPTIONS } from "../constants";

const useStyles = makeStyles(() => ({
  mainContainer: {
    marginTop: 12,
  },
  formControl: {
    marginTop: 26,
  },
}));

export const FilterForm: FunctionComponent<FormRenderProps> = ({
  submitError,
  handleSubmit,
}) => {
  const classes = useStyles();
  const { values } = useFormState();

  const startDate = values.startDate;
  const endDate = values.endDate;

  const maxStartDate = useMemo(
    () => (endDate ? moment(endDate) : moment()),
    [endDate],
  );
  const minEndDate = useMemo(
    () => (startDate ? moment(startDate) : undefined),
    [startDate],
  );

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(e);
  };

  return (
    <form onSubmit={onSubmit}>
      {submitError && <Typography color="error">{submitError}</Typography>}
      <div className={classes.mainContainer}>
        <div>
          <Field
            maxDate={maxStartDate}
            disableToolbar
            variant="inline"
            autoOk
            fullWidth
            name="startDate"
            label="Start Date"
            dateFormat={DATE_FORMATS.frontEnd}
            component={DatePicker}
            placeholder="Start Date"
          />
        </div>
        <div className={classes.formControl}>
          <Field
            minDate={minEndDate}
            maxDate={moment()}
            disableToolbar
            variant="inline"
            autoOk
            fullWidth
            name="endDate"
            label="End Date"
            dateFormat={DATE_FORMATS.frontEnd}
            component={DatePicker}
            placeholder="End Date"
          />
        </div>
        <div className={classes.formControl}>
          <Field
            fullWidth
            name="educationType"
            label="Education Type"
            placeholder="Education Type"
            options={EDUCATION_TYPE_OPTIONS}
            component={Autocomplete}
          />
        </div>
        <div className={classes.formControl}>
          <Button type="submit" color="secondary" variant="contained" fullWidth>
            Search
          </Button>
        </div>
      </div>
    </form>
  );
};

export default React.memo(FilterForm);
